<script>
import { mapActions, mapState } from 'pinia';

import { useUserStore } from '../../../../store/useUserStore.js';

export default {
    name: 'LobbyActionButton',
    components: {
        CpButton: require('../../button').default,
        CpBaseSvgIcon: require('../../base-svg-icon').default,
        CpIcon: require('../../icon').default,
        CpDialog: require('../../dialog').default,
        CpAuthForm: require('../../auth-form/index').default,
        LobbyButtonIcon: require('../../social-feed/icons/lobby-button').default,
        CpVerifyEmailDialog: require('../../dialogs/VerifyEmail').default,
    },
    directives: {
        marginRight: require('../../directives/margins').marginRight,
    },
    props: {
        id: Number,
        handleLobbyDialog: Function,
        title: {type: String, default: 'Contact Lawmaker'},
    },
    data() {
        return {
            showVerifyEmailModal: false,
        };
    },
    methods: {
        async handleLobby() {
            if (this.isUserLogin && !this.userProfileData?.email_verified) {
                await this.getUserProfile().then(
                    () => {
                        if (!this.userProfileData?.email_verified) {
                            this.showVerifyEmailModal = true;
                        } else {
                            this.handleLobbyDialog();
                        }
                    }
                );
            } else {
                this.handleLobbyDialog();
            }
        },
        handleVerifyEmailModal() {
            this.showVerifyEmailModal = !this.showVerifyEmailModal;
        },
        ...mapActions(useUserStore, ['getUserProfile']),
    },
    computed: {
        ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
    },
};
</script>

<template>
    <div>
        <cp-button noborder bold @click="handleLobby" class="btnClass">
            <cp-base-svg-icon :width="26" :height="26" viewBox="0 0 20 19" :icon-color="'var(--primary-blue-400)'" :stroke-color="'none'">
                <LobbyButtonIcon />
            </cp-base-svg-icon>
            <span v-if="!$root.isMobile" class="body primary-blue-400-color">{{ title }}</span>
        </cp-button>
        <CpVerifyEmailDialog v-if="showVerifyEmailModal && isUserLogin" :handleDialog="handleVerifyEmailModal" />
    </div>
</template>

<style scoped>
.button--darkgray-outline {
    transition: color 0.2s ease;
}
.btnClass {
  background-color: transparent;
}
</style>

